import React from 'react';

import { groupBy as groupArray } from 'app/shared/utils/array';
import { DropdownSectionHeader } from 'app/shared/components/atoms';
import { Box } from 'app/shared/components/atoms';

import { SimpleOptions, SimpleOptionsProps } from './Simple';

interface Props<T> extends SimpleOptionsProps<T> {
  'data-qaid'?: string;
  groupBy: (option: T) => string;
}

export const GroupedOptions = <T = any,>({
  options,
  groupBy,
  'data-qaid': qaId,
  invertColors,
  ...rest
}: Props<T>) => {
  const groups = groupArray(options, groupBy);

  const keys = Object.keys(groups);

  return (
    <Box overflowY="scroll" maxHeight="inherit">
      {keys.map((key) => (
        <div key={`group-${key}`} data-qaid={`${qaId}-group`}>
          <DropdownSectionHeader
            data-qaid={`${qaId}-group-${key}-header`}
            invertColors={invertColors}
          >
            {key}
          </DropdownSectionHeader>

          <SimpleOptions<T>
            options={groups[key]}
            invertColors={invertColors}
            {...rest}
          />
        </div>
      ))}
    </Box>
  );
};

export default GroupedOptions;
